export default "__VITE_ASSET__rpu9QHPf__"